import React from 'react';
import {EntityImageUploadButton} from '../../../../shared';

interface CategoryGroupImageUploadButtonProps {
  imageUrl?: string | null;
  isUploading?: boolean;
  onFileSelect: (file: File) => void;
  onRemove?: () => void;
  className?: string;
  withBg?: boolean;
}

export const CategoryGroupImageUploadButton = (props: CategoryGroupImageUploadButtonProps) => (
  <EntityImageUploadButton {...props} notificationKey="category-group-image-upload-error" />
);
